<template>
<div v-if="sanitisedStatus">
  <div class="media-content">
    <b-collapse class="card is-small" collapsible :open="false">
      <div slot="trigger" slot-scope="props" class="card-header">
        <div class="card-header-title"><div class="media">
            <div class="media-left">
              <b-icon :icon="statusIcon" size="is-medium"/>
              <p class="status" v-html="sanitisedStatus"/>
            </div>
            <div class="media-content">
              <b v-if="status && status.operations" >{{status.operations[0].timestamp/1000 | formatDate}}
                {{status.operations[0].timestamp/1000 | formatTime}}</b>
            </div>
          </div></div>
        <a class="card-header-icon">details<b-icon :icon="props.open?'menu-up':'menu-down'"></b-icon></a>
      </div>
      <div class="details">
        <table v-if="params && params.fulfilment">
          <tr><td class="head">Items:</td><td>
              <table>
                <tr v-for="(item, index) in (params.product.product_items || [params.product])">
                  <td><b v-html="clean(item.title)"/></b><br>
                      {{item.page_count}} pages, {{item.format}}
                      <p v-if="devMode" class="devMode">
                        <a :href="DBVIEW_ROOT+'orders/live/'+oid+(index>0?'-'+index:'')"
                           target="_blank"><em>live/{{oid+(index>0?'-'+index:'')}}</em></a><br/>
                      </p>
                  </td>
                  <td>x{{item.quantity}}</td><td>{{item.price_item | formatCurrency}}</td></tr>
                <tr><td><b>Shipping</b></td><td/><td><span v-if="params.product.price_shipping">
                  {{params.product.price_shipping | formatCurrency}}</span>
                <i v-else>Free</i></td></tr>
              </table></td></tr>
          <tr><td class="head">Payment:</td><td>
              paid {{params.product.price_total | formatCurrency}}
              {{params.product.price_currency}}</td></tr>
          <tr><td class="head">Address:</td><td>
              {{params.fulfilment.ship.name}},
              {{params.fulfilment.ship.address}},
              {{params.fulfilment.ship.address2}},
              {{params.fulfilment.ship.city}},
              {{params.fulfilment.ship.postcode}},
              {{params.fulfilment.ship.state}},
              {{params.fulfilment.ship.country}}</td></tr>
          <tr v-if="dispatchInfo">
            <td class="head">Tracking:</td><td>
              {{clean(dispatchInfo.courier)}}
              {{dispatchInfo.track_id}}
              ({{dispatchInfo.timestamp/1000 | formatDate}})
          </td></tr>
          <tr v-if="deliverInfo">
            <td class="head">Delivered:</td><td>
              {{deliverInfo.msg}}
              ({{deliverInfo.timestamp/1000 | formatDate}})
          </td></tr>
          <tr v-if="notes.length">
            <td class="head">Notes:</td><td>
              <i v-for="note in notes">{{note.msg}}
              ({{note.timestamp/1000 | formatDate}})<br/></i>
          </td></tr>
          <tr v-if="devMode" class="devMode">
            <td class="head">:</td><td>
              <a :href="DBVIEW_ROOT+'orders/live/'+oid"
                 target="_blank"><em>live/{{oid}}</em></a><br/>
              <a v-for="file in ['cover','inner','contact']" target="_blank"
                 :href="getOperationParam(file)">
                {{file}} {{parseInt(getOperationParam(file+'Size')/1024/1024)}}M </a>
          </td></tr>
        </table>
      </div>
    </b-collapse>
    
  </div>
</div>
</template>

<script>
import Firebase from '../firebase.js'
var db = Firebase.database

export default {
  name: 'OrderCard',
  data: function() { return {
    DBVIEW_ROOT: Firebase.dbViewUrlRoot,
  }},
  props: {
    'oid': { type: String, required: true }
  },
  firebase() { return {
    params: { source: db.ref('/orders/live/'+this.oid+'/params'), asObject: true },
    status: { source: db.ref('/orders/live/'+this.oid+'/status'), asObject: true },
  }},
  computed: {
    devMode: function() {
      return this.$store.state.dev.developmentClient
    },
    sanitisedStatus: function() {
      const valids = 'dispatched printing delivered cancelled charged'
      const dropids = 'refused'
      if (valids.indexOf(this.status.status) >= 0) {
        return this.status.status
      }
      if (dropids.indexOf(this.status.status) >= 0) {
        return undefined
      }
      return 'processing'
    },
    statusIcon: function() {
      switch (this.sanitisedStatus) {
        case 'cancelled': return 'cancel'
        case 'printing': return 'printer'
        case 'dispatched': return 'truck-fast'
        case 'delivered': return 'emoticon-happy'
        case 'charged': return 'credit-card'
        case 'processing': return 'timelapse'
      }
      return 'help'
    },
    dispatchInfo: function() {
      if (this.status.status=='dispatched' ||
          this.status.status=='delivered') {
        for (var i=this.status.operations.length-1; i>0; i--) {
          if (this.status.operations[i].new_status == 'dispatched') {
            return Object.assign({ timestamp: this.status.operations[i].timestamp },
                                 this.status.operations[i].info)
          }
        }
      }
    },
    deliverInfo: function() {
      if (this.status.status=='delivered') {
        for (var i=this.status.operations.length-1; i>0; i--) {
          if (this.status.operations[i].new_status == 'delivered') {
            return Object.assign({ timestamp: this.status.operations[i].timestamp },
                                 this.status.operations[i].info)
          }
        }
      }
    },
    notes: function() {
      var notes = []
      try {
        for (var i=0; i<this.status.operations.length; i++) {
          var msg = this.status.operations[i].info.userNote
          if (msg) {
            notes.push({ msg, timestamp: this.status.operations[i].timestamp })
          }
          var reprint = this.status.operations[i].info.reprintCause
          if (reprint) {
            if (reprint.indexOf('pixxi')>=0) { reprint = 'other' }
            notes.push({ msg: 'reprint ['+reprint+']', timestamp: this.status.operations[i].timestamp })
          }
        }
      } catch (e) {}
      console.log(notes)
      return notes
    },    
  },
  methods: {
    clean: function(title) {
      return (title||'').replace('undefined','').replace('UNKNOWN_','')
    },
    getOperationParam: function(param) {
      if (!this.status || !this.status.operations) return undefined
      var result = undefined
      this.status.operations.forEach( op => {
        if (op && op.info && op.info[param] !== undefined) {
          result = op.info[param]
        }
      })
      return result
    },
  },
}
</script>

<style scoped>
  .media {
    align-items: baseline;
  }
  .media-left {
      text-align: center;
  }
  .status {
      font-style: italic;
  }
  .details {
      padding-left: 5em;
  }
  table, th, tr, td {
      border: 0 !important;
      padding: 0.2ex !important;
      border-collapse: collapse;
  }
  .head {
      font-weight: lighter;
  }
  .devMode {
      background-color: yellow;
  }
</style>



// WEBPACK FOOTER //
// src/components/OrderCard.vue